import { Box } from '@mui/material';
import { Route, Routes } from 'react-router-dom';

import { RouteGuard } from '@/components/layout/routes/RouteGuard.comp.tsx';
import { ROUTES } from '@/models/route/routes.ts';
import { NotFound } from '@/views/generalError/notFound/NotFound.comp.tsx';

export const AppRoutes = () => {
  return (
    <Box component="main">
      <Routes>
        <Route element={<NotFound />} path="*" />
        {ROUTES.map(({ component: Component, path, permissions }) => (
          <Route
            element={<RouteGuard requiredPermissions={permissions}>{<Component />}</RouteGuard>}
            key={path}
            path={path}
          />
        ))}
      </Routes>
    </Box>
  );
};
